export default "/react/logoMaxMarket-8e8f316a.png";